module.exports = __webpack_public_path__ + "img/improving-finance.588474ae.svg";